const $inject = ['$scope', '$routeParams', '$filter', 'dataService'];

const lbaReasonForTravelSelectCtrl = function ($scope, $routeParams, $filter, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  const dataLookUpDataSource = dataService.spiltDataAt(vm.settings.dataSource, $routeParams);
  const reasonsForTravel  = _.get(dataService.data.activeItem, dataLookUpDataSource);  

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshReasonsForTravel = refreshReasonsForTravel;
  vm.copyItems = copyItems;

  if(vm.selectType === 'multi' && !vm.data) {
    vm.data = [];
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshReasonsForTravel(userSearch) {
    vm.reasonsForTravel = $filter('filter')(reasonsForTravel, userSearch, false);
    vm.data = vm.data.filter(i => vm.reasonsForTravel.find(reason => reason.Code === i));
  }
  
  function copyItems() {
    copyTextToClipboard(vm.data.join(', '));
  }

  function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
  
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
  
    document.body.appendChild(textArea);
  
    textArea.select();
  
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }
  
    document.body.removeChild(textArea);
  }

  vm.taggingFunc = function (event) {
    event.preventDefault();
    let re = /\r?\n|\r/g;
    
    let pasted = event.clipboardData.getData('text/plain').replace(re, '').split(',');
    let pastedCleaned = _.uniq(pasted).map(Function.prototype.call, String.prototype.trim);

    vm.data = _.union(vm.data, pastedCleaned);
  };
};

lbaReasonForTravelSelectCtrl.$inject = $inject;

export default lbaReasonForTravelSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaReasonForTravelSelect/lbaReasonForTravelSelectCtrl.js